// extracted by mini-css-extract-plugin
module.exports = {"content":"RatingCard_content__1S2wu","ratingWrapper":"RatingCard_ratingWrapper__eqqFk","divider":"RatingCard_divider__2EL09","comment":"RatingCard_comment__3fiYm"};